<template>
  <div  >
       <b-navbar toggleable="lg" type="dark"  variant="danger" fixed="top"  >
        <b-navbar-brand href="#" v-on:click="goback()"> Error </b-navbar-brand> 
         <b-navbar-nav class="ml-auto">
                <!-- <b-nav-item-dropdown right>
                                               
                                                <template #button-content>
                                                    ພາສາ
</template>
                        <b-dropdown-item href="#">LA</b-dropdown-item>
                        <b-dropdown-item href="#">EN</b-dropdown-item>
                    </b-nav-item-dropdown>   -->

                <b-nav-item @click="goback()">
                    <b-icon icon="x-lg" aria-hidden="true" variant="light"></b-icon>
                </b-nav-item>
            </b-navbar-nav>
    </b-navbar>
    <div class="d-flex justify-content-center" md="6" >
    <b-card border-variant="dark" header="Error" align="center">
        <b-card-text>{{ $route.query.desc }}</b-card-text>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  methods: {
        goback() {
            this.$router.go(-1)
        }
  }
};
</script>